import defaultConfig from '.';

export default {
  ...defaultConfig,
  loadGDPRScript: true,
  placementOptions: {
    panorama_top: {
      reserveSpace: true,
      width: 980,
      height: 150,
    },
  },
  pageOpts: {
    ...defaultConfig.pageOpts,
    keywords: {
      'no-sno-publishergroup': 'schibsted',
    },
  },
};
